import React from 'react';
import { Error } from '@unimed-fesp/components';

function NotFoundPage() {
  const errorNumber = '404';
  const errorTitle = 'oops! página não encontrado';
  const errorMessage =
    'O servidor não pode encontrar o recurso solicitado. Este código de resposta talvez seja o mais famoso devido à frequência com que acontece na web.';

  return (
    <Error
      httpCode={errorNumber}
      title={errorTitle}
      message={errorMessage}
      hideButtonReaload
    />
  );
}

export default NotFoundPage;
